import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  useMediaQuery,
  Divider,
} from "@mui/material";
import color from "../utils/Colors";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "@mui/icons-material";

interface Role {
  name: string;
  image: string;
}

interface RoleSelectionModalProps {
  open: boolean;
  onClose: () => void;
  setRole: (role: string) => void;
}

const RoleSelectionModal: React.FC<RoleSelectionModalProps> = ({
  open,
  onClose,
  setRole,
}) => {
  const [selectedRole, setSelectedRole] = useState<string>("");

  const handleRoleClick = (role: string) => {
    setSelectedRole(role);
  };

  const handleNextClick = () => {
    if (selectedRole) {
      setRole(selectedRole);
      onClose();
    } else {
      alert("Please select a role.");
    }
  };

  const handleClose = (
    event: {},
    reason: "backdropClick" | "escapeKeyDown"
  ) => {
    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
      onClose();
    }
  };

  const roles = [
    { name: "STUDENT", image: "/assets/student.svg" },
    { name: "TEACHER", image: "/assets/teacher.svg" },
    { name: "ADMIN", image: "/assets/admin.svg" },
    { name: "PARENT", image: "/assets/parent.svg" },
    { name: "INSTRUCTOR", image: "/assets/instructor.svg" },
  ];

  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery("(max-width:900px)");

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: 2,
          p: 4,
          boxShadow: 24,
          maxWidth: "700px",
          width: "100%",
          backgroundImage: "url(/assets/backgroundsvg.svg)",
          backgroundRepeat: "repeat-y",
          backgroundSize: "100%",
        }}
      >
        <Typography
          onClick={() => {
            // onClose()
            navigate("/");
          }}
          sx={{
            margin: 0,
            position: "absolute",
            top: isSmallScreen ? "25px" : "35px",
            color: color.firstColor,
            fontSize: "16px",
            fontWeight: "bold",
            left: 40,
            whiteSpace: "nowrap",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <ChevronLeft></ChevronLeft> Back
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mb: 1,
            mt: { xs: 4, sm: 0 },
            color: color.textColor,
            textAlign: "center",
          }}
        >
          Welcome to Global Genius Index(G2I)
        </Typography>
        <Typography
          variant="h6"
          sx={{
            margin: "auto",
            mb: 4,
            color: color.textColor,
            width: "fit-content",
            // color: "white",
            p: 1,
            px: 4,
            fontSize: "22px",
            borderRadius: 2,
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          Signup As
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr 1fr", sm: "1fr 0.5fr 1fr" },
            gridTemplateRows: { xs: "1fr 1fr 1fr", sm: "1fr 0.1fr" },
            gap: 2,
            justifyItems: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          <Divider
            orientation="horizontal"
            sx={{
              position: "absolute",
              width: "100%",
              top: "50%",
              backgroundColor: "#BB84E8",
              height: "1.5px",
              border: "none",
              zIndex: 1,
            }}
          />

          <Divider
            orientation="vertical"
            sx={{
              position: "absolute",
              height: "100%",
              left: "50%",
              backgroundColor: "#BB84E8",
              width: "1px",
              border: "none",
              zIndex: 1,
            }}
          />
          {roles.map((role: Role, index: number) => {
            const gridAreaMap = ["1 / 1", "1 / 3", "2 / 2", "3 / 1", "3 / 3"];
            const gridAreaMap1 = [
              "1 / 1",
              "1 / 2",
              "2 / 2",
              "2 / 1",
              "3 / 1.5",
            ];

            return (
              <Card
                key={index}
                onClick={() => handleRoleClick(role.name)}
                sx={{
                  zIndex: 2,
                  width: 150,
                  cursor: "pointer",
                  border:
                    selectedRole === role.name
                      ? "2px solid #2E0A57"
                      : "2px solid #29085430",
                  boxShadow:
                    selectedRole === role.name
                      ? "0px 4px 12px rgba(0, 0, 0, 0.2)"
                      : "0px 2px 8px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.02)",
                  },
                  gridArea: { xs: gridAreaMap1[index], sm: gridAreaMap[index] },
                }}
              >
                <CardActionArea>
                  <CardMedia
                    component="img"
                    height="100"
                    image={role.image}
                    alt={role.name}
                    sx={{ objectFit: "contain", pt: 1 }}
                  />
                  <CardContent>
                    <Typography
                      variant="body1"
                      textAlign="center"
                      sx={{ fontWeight:'bold',color:color.textColor }}
                    >
                       {role.name.charAt(0).toUpperCase() + role.name.slice(1).toLowerCase()}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            );
          })}
        </Box>

        <Button
          id="button"
          style={{
            marginLeft: "auto",
            marginTop: "20px",
            background: color.firstColor,
            color: "white",
            marginRight: "10px",
          }}
          onClick={handleNextClick}
        >
          Next
        </Button>
      </Box>
    </Modal>
  );
};

export default RoleSelectionModal;
